import { defineComponent as _defineComponent } from 'vue'
import { BigDecimal } from "@/models/store/big.decimal";
import {computed, onMounted} from "vue";
import {BigIntWrapper, Coin, DecCoin} from "@/models/store/common";
import CoinAmount from "./CoinAmount.vue";
import { useUserStore } from "@/store/user.store";
import DateCommon from "@/components/commons/DateCommon.vue";
import {useBlockStore} from "@/store/block.store";
import dataService from "@/services/data.service";
import {useTokensStore} from "@/store/tokens.store";
import {useConfigurationStore} from "@/store/configuration.store";
import {calculatePrice} from "@/utils/token-price";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AmountView',
  props: {
    coins: { type: Array, required: true },
    precision: { type: Number, required: false },
    reduceBigNumber: { type: Boolean, required: true },
    showDenom: { type: Boolean, required: false },
    showVesting: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const router = useRouter();

const props = __props;
function convertAmount( amount: bigint | number | BigDecimal | Coin | DecCoin){
  if( typeof amount === 'bigint'){
    return new BigIntWrapper(amount);
  } else {
    return amount;
  }
}
const locked = computed(()=> {
  return useUserStore().getVestingLockAmount;
});

const price = computed( ()=>{
  return useTokensStore().getTokenPrice;
});

onMounted(() =>{
  dataService.refreshValidators();
});

function onVestingClick(){
  router.push('/portfolio');
}


const __returned__ = { router, props, convertAmount, locked, price, onVestingClick, CoinAmount, get useUserStore() { return useUserStore }, get calculatePrice() { return calculatePrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})